import { atom } from "recoil";

export interface Pilot {
  id: number;
  name: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface Service {
  id: number;
  product_sub_category_id: number;
  ext_reference_id: number;
  name: string;
  order: number;
  image: string;
  is_recurring: boolean;
  initial_min: number;
  initial_max: number;
  recurring_min: number;
  recurring_max: number;
  monthly_min: number;
  monthly_max: number;
  created_at: string;
  updated_at: string;
  needs_customer_support: boolean;
  description: string | null;
  image_name: string;
}

export interface Plan {
  addons: any;
  agreementLengths: any;
  name: string;
  prices: any;
  serviceTypeId: number;
  isMonthlyBilling: boolean;
  pilot?: Pilot | null;
  services?: Service[];
}

export interface PlansState {
  [key: string]: Plan;
}

const plansAtom = atom<PlansState>({
  key: "plans",
  default: {}
});

export { plansAtom };
